<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title> Mailing address </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>
  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingCountries"
    (click)="loadCountries()"
  >
  </salonmonster-tap-retry>
  <ng-container *ngIf="!isLoading && !errorOccurredWhileLoadingCountries">
    <div class="ion-padding">
      To use this feature a physical business address is required (this is a
      legal compliance requirement). Please enter your details below:
    </div>
    <ng-container *ngIf="!isAdmin">
      <ion-item color="primary">
        Only administrators can edit this page.
      </ion-item>

      <ion-card>
        <ion-card-header>
          {{ salon.getName() }}
        </ion-card-header>
        <ion-card-content>
          {{ salon.getAddress1() }}
          <br />
          {{ salon.getCity() }}
          <br />
          {{ salon.getProvince() }}
          <br />
          {{ salon.getPostal() }}
        </ion-card-content>
      </ion-card>
    </ng-container>
    <form [formGroup]="salonProfileForm" *ngIf="isAdmin">
      <ion-item lines="none">
        <ion-label position="stacked"> Address 1 * </ion-label>
        <ion-input
          type="text"
          name=""
          formControlName="address1"
          clearInput
        ></ion-input>
      </ion-item>
      <ion-item
        lines="none"
        [hidden]="address1.valid || (address1.pristine && !submitted)"
      >
        <p *ngIf="address1.hasError('maxlength')" class="smr-error">
          Address cannot exceed 40 characters.
        </p>
      </ion-item>

      <ion-item lines="none">
        <ion-label position="stacked"> Address 2 </ion-label>
        <ion-input
          type="text"
          name=""
          formControlName="address2"
          clearInput
        ></ion-input>
      </ion-item>
      <ion-item
        lines="none"
        [hidden]="address2.valid || (address2.pristine && !submitted)"
      >
        <p *ngIf="address2.hasError('maxlength')" class="smr-error">
          Address cannot exceed 40 characters.
        </p>
      </ion-item>

      <ion-item lines="none">
        <ion-label position="stacked"> City * </ion-label>
        <ion-input
          type="text"
          name=""
          formControlName="city"
          clearInput
        ></ion-input>
      </ion-item>
      <ion-item
        lines="none"
        [hidden]="city.valid || (city.pristine && !submitted)"
      >
        <p *ngIf="city.hasError('maxlength')">
          City cannot exceed 20 characters.
        </p>
      </ion-item>

      <ion-item lines="none">
        <ion-label position="stacked"> Province/State * </ion-label>
        <ion-input
          type="text"
          name=""
          formControlName="province"
          clearInput
        ></ion-input>
      </ion-item>
      <ion-item
        lines="none"
        [hidden]="province.valid || (province.pristine && !submitted)"
      >
        <p *ngIf="city.hasError('maxlength')">
          Province/State cannot exceed 25 characters.
        </p>
      </ion-item>

      <ion-item lines="none">
        <ion-label position="stacked"> ZIP/Postal * </ion-label>
        <ion-input
          type="text"
          name=""
          formControlName="postal"
          clearInput
        ></ion-input>
      </ion-item>
      <ion-item
        lines="none"
        [hidden]="postal.valid || (postal.pristine && !submitted)"
      >
        <p *ngIf="postal.hasError('maxlength')">
          ZIP/Postal code cannot exceed 7 characters.
        </p>
      </ion-item>

      <ion-item lines="none" class="ion-padding-top">
        <ion-label position="stacked">Country *</ion-label>
        <ion-select
          placeholder="Select a Country"
          interface="popover"
          formControlName="country"
          mode="ios"
        >
          <ion-select-option
            *ngFor="let country of countries"
            [value]="country.getID()"
          >
            {{ country.getCountryName() }}
          </ion-select-option>
        </ion-select>
      </ion-item>
    </form>
  </ng-container>
</ion-content>

<ion-footer>
  <ion-toolbar class="ion-no-padding">
    <ion-row>
      <ion-col>
        <ion-button expand="block" (click)="onSalonProfileSave()" *ngIf="isAdmin">
          Save
        </ion-button>
        <ion-button expand="block" (click)="onDismiss()" *ngIf="!isAdmin">
          OK
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>
